export interface PersonalSchedule {
  trainingDays?: number[];
  trainingStartTime?: string;
  trainingDayTimes?: Record<string, string>;
  availableEquipment?: string[];
  mealTimes?: Partial<Record<'breakfast' | 'lunch' | 'dinner' | 'snack', string>>;
  dietCyclePreference?: 'steady' | 'short';
}
export const WEEKDAY_LABELS = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
export const validClock = (value: unknown): value is string => typeof value === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(value);
export function normalizedTrainingDays(days: unknown): number[] {
  return Array.isArray(days) ? [...new Set(days.filter(d => Number.isInteger(d) && d >= 1 && d <= 7))].sort((a, b) => a - b) : [];
}
export function frequencyForDays(days: number): '1-2' | '3-4' | '5-6' {
  return days <= 2 ? '1-2' : days <= 4 ? '3-4' : '5-6';
}
export function trainingClock(schedule: PersonalSchedule, day: number): string | undefined {
  const clock = schedule.trainingDayTimes?.[day] || schedule.trainingStartTime;
  return validClock(clock) ? clock : undefined;
}
export function clockMinutes(clock: string): number {
  const [hour, minute] = clock.split(':').map(Number); return hour * 60 + minute;
}
export function minutesClock(value: number): string {
  const minute = ((Math.round(value) % 1440) + 1440) % 1440;
  return `${String(Math.floor(minute / 60)).padStart(2, '0')}:${String(minute % 60).padStart(2, '0')}`;
}
export function timeSlotForClock(clock: string): 'morning-early' | 'morning' | 'noon' | 'afternoon' | 'evening' | 'night' {
  const hour = clockMinutes(clock) / 60;
  return hour < 8 ? 'morning-early' : hour < 11 ? 'morning' : hour < 13 ? 'noon' : hour < 16 ? 'afternoon' : hour < 19 ? 'evening' : 'night';
}
export function scheduleFields(source: PersonalSchedule, includeMissing = false): PersonalSchedule {
  const fields: PersonalSchedule = { trainingDays: source.trainingDays, trainingStartTime: source.trainingStartTime,
    trainingDayTimes: source.trainingDayTimes, availableEquipment: source.availableEquipment,
    mealTimes: source.mealTimes, dietCyclePreference: source.dietCyclePreference };
  return includeMissing ? fields : Object.fromEntries(Object.entries(fields).filter(([, value]) => value !== undefined));
}
